<template>
    <div class="content-wrapper intro-welcome">
        <div class="d-flex align-items-center full-height">
            <div class="row">
                <div class="col-md-4">
                    <h1 class="general-title">Welcome to the Atelier Passoni</h1>
                    <p class="general-content">Our mission is to produce the most beautiful, timeless, lightweight and high performance bikes possible. This configurator is the start of your journey with Passoni. We’ll guide you through the process of customising your perfect bike.</p>
                    <p class="general-content">The configuration process will take 10 – 15 minutes. You can save your progress at any point and return to it later.</p>
                    <button class="btn btn-outline-primary" v-on:click="$emit('go-next')">Start configuration</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: "intro-welcome",
  data() {
    return {}
  },
  mounted() {
      this.$emit('set-intro-background')
  }
}
</script>

<style scoped>

</style>

<style lang="scss" scoped>
body {
    background-image: url('/background-intro.png');
    background-size: cover;
    background-repeat: no-repeat;
    background-position-x: right;
    background-position-y: center;
}
h1 {
    margin-bottom: 40px;
}

button {
    margin-top: 30px;
}

@media (max-width: 767px) {
    body {
        background-image: none;
    }
}
</style>